import React from 'react';
import {connect} from 'react-redux';
import OptimizeButton from 'components/molecules/optimize-button';
import {BaseDashboard} from '../base-dashboard';

class Dashboard extends BaseDashboard {
    render() {
        const keyPlayersQuantity = this.getKeyPlayersQuantity();
        const lineupsQuantity = this.getLineupsQuantity();

        return (
            <div className="players-heading">
                <strong>{keyPlayersQuantity}</strong> QB Used |<strong>{lineupsQuantity}</strong> Lineups
                <OptimizeButton />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        filterLineupsByCorrelationStackCombinations,
        lineupsData: {rawLineups},
    } = state;

    return {
        rawLineups,
        filterLineupsByCorrelationStackCombinations,
    };
}

export default connect(mapStatesToProps)(Dashboard);
